import { ShieldCheck, Lock, FileCheck, Heart, RefreshCw } from 'lucide-react';

export const principles = [
  {
    icon: ShieldCheck,
    title: 'Truth over capture.',
    description: 'Accuracy that survives audit, never numbers that merely inflate. When the two pull against each other, truth wins.',
  },
  {
    icon: Lock,
    title: 'Ownership, not lock-in.',
    description: 'The client owns the data, the pipelines, and the IP, end to end. We build assets that belong to them, not dependencies on us.',
  },
  {
    icon: FileCheck,
    title: 'Evidence for every number.',
    description: 'Every code is bound to documentation, and every result is traceable to its source, its version, and the person who reviewed it.',
  },
  {
    icon: Heart,
    title: 'The patient is the point.',
    description: 'Underneath the Stars, the RAF scores, and the dollars, every feature has to help a patient or the person caring for them.',
  },
  {
    icon: RefreshCw,
    title: 'A lifecycle relationship, not a handoff.',
    description: 'We stay. We manage the full lifecycle of how the client uses what we build, because the system gets sharper the longer we\'re in it.',
  },
];
